<div class="pb-24">
  <h3>{{ 'USER.CONFIG.CALENDAR.TITLE' | translate }}</h3>
  <span class="py-24">{{ 'USER.CONFIG.CALENDAR.STATEMENT' | translate }}</span>
  <div
    *ngIf="googleAuthValidation$ | async as googleAuthValidation; else error"
    class="flex-row-container justify-between items-center pt-24 px-16">
    <div class="flex-row-container gap-16 items-center">
      <img src="/assets/svg/calendar_google.svg" />
      <div class="flex-col-container">
        <span class="fs-12 text-light-gray">Status</span>
        <span class="fw-500" [class]="googleAuthValidation.data ? 'success_status': 'text-black'"
          >{{ (googleAuthValidation.data ? 'USER.CONFIG.CALENDAR.LINKED' : 'USER.CONFIG.CALENDAR.NO_LINKED') | translate }}</span
        >
      </div>
    </div>
    <a *ngIf="!googleAuthValidation.data" mat-flat-button color="primary" [href]="googleAuthUrl$ | async"
      >{{ 'USER.CONFIG.CALENDAR.BUTTON' | translate }}</a
    >
  </div>
  <ng-template #error>
    <div *ngIf="isError; else loading" class="error_status pt-16">{{ 'USER.CONFIG.CALENDAR.ERROR' | translate }}</div>
    <ng-template #loading>
      <div class="flex-row-container w-all mt-16 justify-center">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </ng-template>
  </ng-template>
</div>
